
export { Link } from "/vercel/path0/libs/common/next-ui/src/lib/link/link.tsx"